import axios from '../../http.service';

export const GET_MARKER_MEETINGS = 'GET_MARKER_MEETINGS';
export const GET_CENTRAL_MARKER_MEETINGS = 'GET_CENTRAL_MARKER_MEETINGS';
export const GET_ALL_MEETING_YEARS = 'GET_ALL_MEETING_YEARS';
export const REPORT_ERROR = 'REPORT_ERROR';

export const getAllMeetingYears = (query) => {
    return async dispatch => {
        try {
            let resp = await axios.get(`/api/v2/reports/meetings/getAllMeetingYears?appointmentType=${JSON.stringify(query)}`);
            resp.status === 200 ? dispatch({ type: GET_ALL_MEETING_YEARS, payload: resp.data }) : dispatch({ type: REPORT_ERROR, payload: resp.data });
        } catch (error) {
            dispatch({
                type: REPORT_ERROR,
                payload: {
                    data: [],
                    errors: ['Error while fetching meeting year data', error.message]
                }
            })
        }
    };
};
export const getMarkerMeetings = (appointmentTypes, year, query) => {
	return async dispatch => {
        try {
			let types = Object.assign({}, appointmentTypes);
            let resp = await axios.get(`/api/v2/reports/meetings/${year}/${JSON.stringify(types)}?pagination=${JSON.stringify(query)}`);
            resp.status === 200 ? dispatch({ type: GET_MARKER_MEETINGS, payload: resp.data }) : dispatch({ type: REPORT_ERROR, payload: resp.data });
        } catch (error) {
			dispatch({
				type: REPORT_ERROR,
				payload: {
					data: [],
					errors: ['Error while fetching Marker Meetings Data', error.message]
				}
			});
		}
	};
};

export const getCentralMarkerMeetings = (appointmentTypes, year, query) => {
	return async dispatch => {
		try {
			let types = Object.assign({}, appointmentTypes);
			let resp = await axios.get(`/api/v2/reports/meetings/${year}/${JSON.stringify(types)}?pagination=${JSON.stringify(query)}`);
			resp.status === 200
				? dispatch({
						type: GET_CENTRAL_MARKER_MEETINGS,
						payload: resp.data
				  })
				: dispatch({ type: REPORT_ERROR, payload: resp.data });
		} catch (error) {
			dispatch({
				type: REPORT_ERROR,
				payload: {
					data: [],
					errors: ['Error while fetching Central Marker Meetings Data', error.message]
				}
			});
		}
	};
};
